import EServices from './EServices.js';
import DecyzjeWZ from './DecyzjeWZ';
import UsuniecieDrzew from './UsuniecieDrzew';

import SporzadzenieMPZP from './SporzadzenieMPZP';
import ZezwolenieAlkohol from './ZezwolenieAlkohol';
import ZmianaCeluPublicznego from './ZmianaCeluPublicznego';
import ZmianaMPZP from './ZmianaMPZP';
import UstalenieNumeruPorzadkowego from './UstalenieNumeruPorzadkowego';
import OplataPlanistyczna from './OplataPlanistyczna';
import DecyzjeULICP from './DecyzjeULICP';
import DecyzjaSrodowiskowa from './DecyzjaSrodowiskowa';
import ZaswiadczenieEMUIA from './ZaswiadczenieEMUIA.js';
import ServiceWMSWFS from './ServiceWMSWFS';
import InvestContact from './InvestContact';
import InvestContactForm from './InvestContactForm';
import ZmianaWarunkowZabudowy from './ZmianaWarunkowZabudowy'
import ZmianaSUIKZP from './ZmianaSUIKZP'
import PrzeniesienieSrodowiskowychUwarunkowan from './PrzeniesienieSrodowiskowychUwarunkowan'
import PrzeniesienieDecyzjiOWarunkachZabudowy from './PrzeniesienieDecyzjiOWarunkachZabudowy'

export const AllServices = {
  NrIPowDzialkiInfo: {
    title: 'Pozyskiwanie informacji o numerach działek i ich powierzchniach',
    shortName: 'NrIPowDzialkiInfo',
    confirmText: null,
    requiresUserInfo: false,
    signWithEPUAP: false,
    Component: EServices,
    returnsDoc: true,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  PrzebiegDrogiInfo: {
    title: 'Pozyskanie informacji o przebiegu i numeracji dróg gminnych',
    shortName: 'PrzebiegDrogiInfo',
    confirmText: null,
    requiresUserInfo: false,
    signWithEPUAP: false,
    Component: EServices,
    returnsDoc: true,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: true,
    },
    disabled: false,
  },
  DecyzjeWZ: {
    title: 'Wniosek o wydanie decyzji o warunkach zabudowy',
    shortName: 'DecyzjeWZ',
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: DecyzjeWZ,
    returnsDoc: false,
    cost: 107,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
  },
  DecyzjeULICP: {
    title: 'Wniosek o wydanie decyzji o ustaleniu lokalizacji inwestycji celu publicznego',
    shortName: 'DecyzjeULICP',
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: DecyzjeULICP,
    returnsDoc: false,
    cost: 107,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
    disabled: false,
  },
  DecyzjaSrodowiskowa: {
    title: 'Wniosek o wydanie decyzji o środowiskowych uwarunkowaniach',
    shortName: 'DecyzjaSrodowiskowa',
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: DecyzjaSrodowiskowa,
    returnsDoc: false,
    cost: 205,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
    disabled: false,
  },
  ZaswiadczenieEMUIA: {
    title: 'Wniosek o wydanie zaświadczenia o ustalonym numerze porządkowym budynku',
    shortName: 'ZaswiadczenieEMUIA',
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: ZaswiadczenieEMUIA,
    returnsDoc: false,
    cost: 17,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
    disabled: false,
  },
  PrzeniesienieDecyzjiOWarunkachZabudowy: {
    title: 'Wniosek o przeniesienie decyzji o warunkach zabudowy na rzecz innej osoby',
    shortName: 'PrzeniesienieDecyzjiOWarunkachZabudowy',
    confirmText: null,
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: PrzeniesienieDecyzjiOWarunkachZabudowy,
    returnsDoc: true,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false,
    },
  },
  WlasnoscDzialkiInfo: {
    title: 'Pozyskiwanie informacji o właścicielach/własności działek',
    shortName: 'WlasnoscDzialkiInfo',
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    requiresUserInfo: false,
    signWithEPUAP: false,
    Component: EServices,
    returnsDoc: true,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  ZagospDzialkiInfo: {
    title: 'Sprawdzenie sposobu zagospodarowania poszczególnych działek',
    shortName: 'ZagospDzialkiInfo',
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    requiresUserInfo: false,
    signWithEPUAP: false,
    Component: EServices,
    returnsDoc: true,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  ZimoweUtrzymanieDrog: {
    title: 'Pozyskanie informacji o zimowym utrzymaniu dróg',
    shortName: 'ZimoweUtrzymanieDrog',
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    requiresUserInfo: false,
    signWithEPUAP: false,
    Component: EServices,
    returnsDoc: true,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: true,
    },
    disabled: false,
  },
  PobierzWMSiWFS: {
    title: 'Usługa pobrania WMS i WFS',
    shortName: 'PobierzWMSiWFS',
    confirmText: null,
    requiresUserInfo: false,
    Component: ServiceWMSWFS,
    returnsDoc: false,
    signWithEPUAP: false,
    mapConfig: {
      enableAddress: false,
      enablePrecints: false,
      enableParcels: false,
      enableMultiselect: false,
      enableRoads: false,
    },
    disabled: false,
  },
  WypisIWyrysZeStudium: {
    title: 'Wypis i wyrys ze studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    shortName: 'WypisIWyrysZeStudium',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: EServices,
    returnsDoc: false,
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie wypisu i wyrysu ze studium uwarunkowań i kierunków zagospodarowania przestrzennego dla wskazanego terenu.',
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  WypisZeStudium: {
    title: 'Wypis ze studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    shortName: 'WypisZeStudium',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: EServices,
    returnsDoc: false,
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie wypisu i wyrysu ze studium uwarunkowań i kierunków zagospodarowania przestrzennego dla wskazanego terenu.',
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  WyrysZeStudium: {
    title: 'Wyrys ze studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    shortName: 'WyrysZeStudium',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: EServices,
    returnsDoc: false,
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie wypisu i wyrysu ze studium uwarunkowań i kierunków zagospodarowania przestrzennego dla wskazanego terenu.',
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  WypisIWyrysZMpzp: {
    title: 'Wniosek o wypis i wyrys z miejscowego planu zagospodarowania przestrzennego',
    shortName: 'WypisIWyrysZMpzp',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: EServices,
    returnsDoc: false,
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie wypisu i wyrysu z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  WypisZMpzp: {
    title: 'Wypis z miejscowego planu zagospodarowania przestrzennego',
    shortName: 'WypisZMpzp',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: EServices,
    returnsDoc: false,
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie wypisu i wyrysu z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  WyrysZMpzp: {
    title: 'Wyrys z miejscowego planu zagospodarowania przestrzennego',
    shortName: 'WyrysZMpzp',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: EServices,
    returnsDoc: false,
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie wypisu i wyrysu z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  ZaswiadczenieMPZP: {
    title:
      'Wniosek o wydanie zaświadczenia o przeznaczeniu w miejscowym planie zagospodarowania przestrzennego działki',
    shortName: 'ZaswiadczenieMPZP',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: EServices,
    returnsDoc: false,
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  ZaswiadczenieStudium: {
    title:
      'Wniosek o wydanie zaświadczenia ze studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    shortName: 'ZaswiadczenieStudium',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: EServices,
    returnsDoc: false,
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia ze studium uwarunkowań i kierunków zagospodarowania przestrzennego.',
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  uproszczony_wypis: {
    title: 'Uproszczony wypis z miejscowego planu zagospodarowania przestrzennego',
    shortName: 'uproszczony_wypis',
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: EServices,
    returnsDoc: false,
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  wypis_i_wyrys: {
    title: 'Wypis i wyrys z miejscowego planu zagospodarowania przestrzennego',
    shortName: 'wypis_i_wyrys',
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: EServices,
    returnsDoc: false,
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: true,
      enableRoads: false
    },
    disabled: false,
  },
  invest_contact: {
    title: 'List intencyjny inwestora',
    shortName: 'invest_contact',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: InvestContact,
    returnsDoc: false,
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    mapConfig: {
      enableAddress: false,
      enablePrecints: false,
      enableParcels: false,
      enableMultiselect: false,
      enableRoads: false
    },
    disabled: false,
  },
  invest_contact_form: {
    title: 'Formularz kontaktowy dla inwestora',
    shortName: 'invest_contact_form',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: InvestContactForm,
    returnsDoc: false,
    confirmText:
      'Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym wnioskuję o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.',
    mapConfig: {
      enableAddress: false,
      enablePrecints: false,
      enableParcels: false,
      enableMultiselect: false,
      enableRoads: false
    },
    disabled: false,
  },
  decyzje_su: {
    title: 'Wniosek o wydanie decyzji środowiskowej',
    shortName: 'decyzje_su',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: InvestContact,
    returnsDoc: false,
    confirmText: '',
    mapConfig: {
      enableAddress: false,
      enablePrecints: false,
      enableParcels: false,
      enableMultiselect: false,
      enableRoads: false
    },
    disabled: true,
  },
  wziulicp: {
    title:
      'Wniosek o wydanie decyzji o warunkach zabudowy lub decyzji o ustaleniu lokalizacji inwestycji celu publicznego',
    shortName: 'wziulicp',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: InvestContact,
    returnsDoc: false,
    confirmText: '',
    mapConfig: {
      enableAddress: false,
      enablePrecints: false,
      enableParcels: false,
      enableMultiselect: false,
      enableRoads: false
    },
    disabled: true,
  },
  wmc: {
    title: 'Wniosek o miejsce na cmentarzu',
    shortName: 'wmc',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: InvestContact,
    returnsDoc: false,
    confirmText: '',
    mapConfig: {
      enableAddress: false,
      enablePrecints: false,
      enableParcels: false,
      enableMultiselect: false,
      enableRoads: false
    },
    disabled: true,
  },
  UsuniecieDrzew: {
    title: 'Wniosek o wydanie zezwolenia na usunięcie drzew lub krzewów',
    shortName: 'UsuniecieDrzew',
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: UsuniecieDrzew,
    returnsDoc: false,
    cost: 107,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
  },
  SporzadzenieMPZP: {
    title: 'Wniosek o sporządzenie miejscowego planu zagospodarowania przestrzennego',
    shortName: 'SporzadzenieMPZP',
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: SporzadzenieMPZP,
    returnsDoc: false,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
  },
  OplataPlanistyczna: {
    title: 'Wniosek o ustalenie opłaty planistycznej przed zbyciem nieruchomości',
    shortName: 'OplataPlanistyczna',
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: OplataPlanistyczna,
    returnsDoc: false,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
  },
  ZmianaMPZP: {
    title: 'Wniosek o zmianę miejscowego planu zagospodarowania przestrzennego',
    shortName: 'ZmianaMPZP',
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: ZmianaMPZP,
    returnsDoc: false,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
  },
  UstalenieNumeruPorzadkowego: {
    title: 'Wniosek o ustalenie numeru porządkowego budynku',
    shortName: 'UstalenieNumeruPorzadkowego',
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: UstalenieNumeruPorzadkowego,
    returnsDoc: false,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
  },
  ZezwolenieAlkohol: {
    title: 'Wniosek o wydanie zezwolenia na sprzedaż napojów alkoholowych ',
    shortName: 'ZezwolenieAlkohol',
    requiresUserInfo: true,
    signWithEPUAP: false,
    Component: ZezwolenieAlkohol,
    returnsDoc: false,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
  },
  ZmianaCeluPublicznego: {
    title: 'Wniosek o zmianę decyzji o ustaleniu lokalizacji inwestycji celu publicznego',
    shortName: 'ZmianaCeluPublicznego',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: ZmianaCeluPublicznego,
    returnsDoc: false,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
  },
  ZmianaWarunkowZabudowy: {
    title: 'Wniosek o zmianę decyzji o warunkach zabudowy',
    shortName: 'ZmianaWarunkowZabudowy',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: ZmianaWarunkowZabudowy,
    returnsDoc: false,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
  },
  ZmianaSUIKZP: {
    title: 'Wniosek o zmianę studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    shortName: 'ZmianaSUIKZP',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: ZmianaSUIKZP,
    returnsDoc: false,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
  },
  PrzeniesienieSrodowiskowychUwarunkowan: {
    title: 'Wniosek o przeniesienie decyzji o środowiskowych uwarunkowaniach',
    shortName: 'PrzeniesienieSrodowiskowychUwarunkowan',
    requiresUserInfo: true,
    signWithEPUAP: true,
    Component: PrzeniesienieSrodowiskowychUwarunkowan,
    returnsDoc: false,
    mapConfig: {
      enableAddress: false,
      enablePrecints: true,
      enableParcels: true,
      enableMultiselect: false,
      enableRoads: false,
    },
  },
};



// WEBPACK FOOTER //
// src/routes/eservices/AllServices.js